import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TabHomePageRoutingModule } from './tab-home-routing.module';

import { TabHomePage } from './tab-home.page';
import {SharedModule} from '../shared/shared.module';
import {DirectivesModule} from '../directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TabHomePageRoutingModule,
        SharedModule,
        DirectivesModule
    ],
  declarations: [TabHomePage]
})
export class TabHomePageModule {}
